import type { ReportErrorType } from "../../../../report-error/report-error.types";
import type {
	ReportErrorSelectOption,
	ReportEventGroup,
} from "./reportError.types";

export const REPORT_ERROR_LABELS = {
	title: "reportError.title",
	successTitle: "reportError.successTitle",
	successDescription: "reportError.successDescription",
	okay: "reportError.okay",
	eventDetails: "reportError.eventDetails",
	playerDetails: "reportError.playerDetails",
	time: "reportError.time",
	duration: "reportError.duration",
	type: "reportError.type",
	name: "reportError.name",
	number: "reportError.number",
	club: "reportError.club",
	errorType: "reportError.errorType.label",
	selectClub: "reportError.selectClub",
	selectCorrectPlayer: "reportError.selectCorrectPlayer",
	selectWrongEvent: "reportError.selectWrongEvent",
	correctEvent: "reportError.correctEvent",
	resetAll: "reportError.resetAll",
	description: "reportError.description",
	descriptionPlaceholder: "reportError.descriptionPlaceholder",
	cancel: "reportError.cancel",
	send: "reportError.send",
	sending: "reportError.sending",
	choose: "reportError.choose",
	noOptionsAvailable: "reportError.noOptionsAvailable",
	homeTeamFallback: "reportError.homeTeamFallback",
	awayTeamFallback: "reportError.awayTeamFallback",
	unknownPlayerFallback: "reportError.unknownPlayerFallback",
	noPlayersAvailable: "reportError.noPlayersAvailable",
	noWrongEventsAvailable: "reportError.noWrongEventsAvailable",
	noEventTypesAvailable: "reportError.noEventTypesAvailable",
} as const satisfies Record<string, string>;

export const TYPE_CHIP_COLORS = [
	"reportErrorModal__typeChip--orange",
	"reportErrorModal__typeChip--mint",
	"reportErrorModal__typeChip--blue",
	"reportErrorModal__typeChip--gray",
] as const;

export const ERROR_TYPE_OPTIONS: Array<
	ReportErrorSelectOption<ReportErrorType> & { labelKey: string }
> = [
	{
		value: "wrong_player",
		label: "",
		labelKey: "reportError.errorType.wrongPlayer",
	},
	{
		value: "wrong_event_type",
		label: "",
		labelKey: "reportError.errorType.wrongEventType",
	},
	{
		value: "event_missing",
		label: "",
		labelKey: "reportError.errorType.eventMissing",
	},
	{
		value: "duplicated_event",
		label: "",
		labelKey: "reportError.errorType.duplicatedEvent",
	},
	{ value: "other", label: "", labelKey: "reportError.errorType.other" },
];

export const REPORT_EVENT_GROUPS: ReportEventGroup[] = [
	{
		labelKey: "reportError.eventGroup.offensive",
		options: [
			{
				value: "shot",
				labelKey: "reportError.eventType.shot",
				categoryKey: "reportError.eventGroup.offensive",
			},
			{
				value: "take_on",
				labelKey: "reportError.eventType.takeOn",
				categoryKey: "reportError.eventGroup.offensive",
				aliases: ["takeOn"],
			},
			{
				value: "goal",
				labelKey: "reportError.eventType.goal",
				categoryKey: "reportError.eventGroup.offensive",
			},
			{
				value: "foul_won",
				labelKey: "reportError.eventType.foulWon",
				categoryKey: "reportError.eventGroup.offensive",
				aliases: ["foulWon"],
			},
			{
				value: "offside",
				labelKey: "reportError.eventType.offside",
				categoryKey: "reportError.eventGroup.offensive",
			},
			{
				value: "technical_error",
				labelKey: "reportError.eventType.technicalError",
				categoryKey: "reportError.eventGroup.offensive",
				aliases: ["technicalError"],
			},
		],
	},
	{
		labelKey: "reportError.eventGroup.defensive",
		options: [
			{
				value: "own_goal",
				labelKey: "reportError.eventType.ownGoal",
				categoryKey: "reportError.eventGroup.defensive",
				aliases: ["goalOwn"],
			},
			{
				value: "foul",
				labelKey: "reportError.eventType.foulCommitted",
				categoryKey: "reportError.eventGroup.defensive",
				aliases: ["foul_committed", "foulCommited"],
			},
			{
				value: "block",
				labelKey: "reportError.eventType.block",
				categoryKey: "reportError.eventGroup.defensive",
			},
			{
				value: "interception",
				labelKey: "reportError.eventType.interception",
				categoryKey: "reportError.eventGroup.defensive",
			},
			{
				value: "recovery",
				labelKey: "reportError.eventType.looseBallRecovery",
				categoryKey: "reportError.eventGroup.defensive",
				aliases: ["loseBallRecovery"],
			},
			{
				value: "tackle",
				labelKey: "reportError.eventType.tackle",
				categoryKey: "reportError.eventGroup.defensive",
			},
			{
				value: "clearance",
				labelKey: "reportError.eventType.clearance",
				categoryKey: "reportError.eventGroup.defensive",
			},
			{
				value: "card",
				labelKey: "reportError.eventType.card",
				categoryKey: "reportError.eventGroup.defensive",
			},
			{
				value: "take_on_against",
				labelKey: "reportError.eventType.takeOnAgainst",
				categoryKey: "reportError.eventGroup.defensive",
				aliases: ["takeOnAgainst"],
			},
		],
	},
	{
		labelKey: "reportError.eventGroup.distribution",
		options: [
			{
				value: "aerial_duel",
				labelKey: "reportError.eventType.aerialDistribution",
				categoryKey: "reportError.eventGroup.distribution",
				aliases: ["aerialDuel"],
			},
			{
				value: "pass",
				labelKey: "reportError.eventType.pass",
				categoryKey: "reportError.eventGroup.distribution",
			},
			{
				value: "pass_received",
				labelKey: "reportError.eventType.passReceived",
				categoryKey: "reportError.eventGroup.distribution",
				aliases: ["passReceived"],
			},
		],
	},
	{
		labelKey: "reportError.eventGroup.goalKeeper",
		options: [
			{
				value: "catch_interception",
				labelKey: "reportError.eventType.catchInterception",
				categoryKey: "reportError.eventGroup.goalKeeper",
				aliases: ["catchInterception"],
			},
			{
				value: "punch",
				labelKey: "reportError.eventType.punch",
				categoryKey: "reportError.eventGroup.goalKeeper",
			},
			{
				value: "goal_conceded",
				labelKey: "reportError.eventType.concededGoal",
				categoryKey: "reportError.eventGroup.goalKeeper",
				aliases: ["goalConceded"],
			},
			{
				value: "save",
				labelKey: "reportError.eventType.save",
				categoryKey: "reportError.eventGroup.goalKeeper",
			},
		],
	},
];
